import { listSVGIcon01 } from "./01.svg"
import { listSVGIcon02 } from "./02.svg"
import { listSVGIcon03 } from "./03.svg"
import { listSVGIcon04 } from "./04.svg"
import { listSVGIcon05 } from "./05.svg"

const listSVGIcon = {
  ...listSVGIcon01,
  ...listSVGIcon02,
  ...listSVGIcon03,
  ...listSVGIcon04,
  ...listSVGIcon05,
}

export default listSVGIcon
